import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../img/Hibbert_logo.svg";
import okta from "../img/Hibbert_Okta.svg";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { clearToken } from "../redux/RTK/authSlice";
function Header({ onMenuClick }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const exp = useSelector((state) => state.auth.exp);

  useEffect(() => {
    if (exp) {
      const isExpired = Date.now() >= exp * 1000;
      if (isExpired) {
        dispatch(clearToken());
        navigate("/accessDenied");
      }
    }
  }, [exp, navigate, dispatch]);

  return (
    <header
      role="banner"
      className="suite-header-bar clearfixshadow-1 is-fixed"
    >
      <div className="banner-logo">
        <Link id="cms-logo" to="https://hibbertordering.com/home">
          <img src={logo} alt="Homepage" />
        </Link>
      </div>
      <div id="cms-top-nav">
        <ul>
          <li>
            <Link
              className="okta"
              to="https://hibbert.okta.com/"
              target="_blank"
            >
              <img src={okta} alt="Okta" />
            </Link>
          </li>
        </ul>
      </div>
      <div className="dropdown">
        <button
          type="button"
          id="cms-menu-trigger"
          className="cms-menu-trigger"
          onClick={onMenuClick}
        >
          <span className="cms-menu-icon"></span>
        </button>
      </div>
    </header>
  );
}

export default Header;
